import React, { useState, useEffect, useMemo } from 'react';

// import DialogComp from '../../../../Core/Dialog/DialogComp';
import VehicleCategoryModal from './VehicleCategoryModal';
// import { BreadCrumbs, EditButton, formatters } from '../../../../Core/Controls';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import { EditButton, SquareButton } from '../../../Core/FormInput/AppButton';
import formatters from '../../../Core/Grid/inputFormatter';
import DialogComp from '../../../Core/Modal/dialogModal';
import AddIcon from '@material-ui/icons/Add';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';

const crumbs = [
    { name: 'Home', path: '/' },
    // { name: 'Vehicles', active: true },
    { name: 'Vehicle Categories', active: true }
];
const base_columns = [
    { field: 'action', title: 'Action', width: '5%' },
    { field: 'vehicleCategoryDescription', title: 'Description' },
    { field: 'vehicleCategoryActive', title: 'Is Active ?', formatter: formatters.YesNo, width: '15%' }
];

function VehicleCategory(props) {
    const [state, setState] = useState({
        vehicleCategoryList: [],
        loader: true,
        open: false
    });

    // useEffect(async () => {
    //     pullVehicleCategory();
    // }, []);

    const pullVehicleCategory = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };

    const vehicleCategoryHandler = (param) => {
        setState((state) => ({ ...state, open: true, vehicleCategoryID: param ? param.vehicleCategoryID : null }));
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => vehicleCategoryHandler()}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => vehicleCategoryHandler(record)}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let actionCol = newColumn.find((item) => item.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton;
        }
        return newColumn;
    }, []);

    const title = state.vehicleCategoryID ? 'Update Vehicle Category' : 'Add Vehicle Category';

    const closeModal = (res) => {
        setState((state) => ({ ...state, open: false, vehicleCategoryID: null }));
        res && pullVehicleCategory();
    };

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />

            <ReportGijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'VehicleCategories'}
                AddBtn={addButton}
                isReload={state.isReload}
            />
            {state.open ? (
                <DialogComp title={title} onClose={() => closeModal(false)} maxWidth="md" fullWidth>
                    <VehicleCategoryModal vehicleCategoryID={state.vehicleCategoryID} onClose={() => closeModal(true)} />
                </DialogComp>
            ) : null}
        </div>
    );
}

export default VehicleCategory;
